import React from "react";
import { GoogleMap } from "../../../components/Map/GoogleMap";
import { useHomePageContext } from "../context/HomePageContext";

/**
 * MapSection component - Self-contained map display
 * Following Clean Code principle: Zero props, uses context for error state
 */
export const MapSection: React.FC = () => {
  const { computed } = useHomePageContext();

  if (computed.hasApiErrors) {
    return null;
  }

  return (
    <div className="mb-4 h-[300px] w-full">
      <div className="h-full w-full overflow-hidden rounded-lg bg-white p-3 shadow-md">
        <GoogleMap
          mapContainerStyle={{
            width: "100%",
            height: "100%",
            borderRadius: "5px",
          }}
        />
      </div>
    </div>
  );
};
